$('.logo-content').slick({
  slidesToShow: 1,
  slidesToScroll: 1,
  arrows: false,
  fade: true,
  asNavFor: '.logo-bar'   
});
$('.logo-bar').slick({
  slidesToShow: 5,
  slidesToScroll: 5,
  asNavFor: '.logo-content',
  dots: false,
  focusOnSelect: true  
});
$('.main_product_img').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    fade: true,
    asNavFor: '.below-main-image .inner',
    responsive: [
        {
          breakpoint: 719,
          settings: {
             dots: true,
          }
        }
      ]
  });

  $('.below-main-image .inner').slick({
    slidesToShow: 4,
    slidesToScroll: 1,
    asNavFor: '.main_product_img',
    arrows: true,
    loop:true,
    dots: false,
    vertical: true,
    verticalSwiping: true,
    centerMode: false,
    focusOnSelect: true,
    responsive: [
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1
        }
      }
    ]
  });

$(document).ready(function() {
  $( ".product-form-grid .option-values" ).each(function() {
  var value_txt = $(this).find('input.option-value-input:checked').val();
  $(this).prev('.option-header').find('.option_value').html(value_txt); 
  });
  
  $( ".product-form-grid .option-value .option-value-input" ).click(function() {
    var value_radio = $(this).val();
    $(this).parents('.option-values').prev('.option-header').find('.option_value').html(value_radio);
  });

  $( ".product-form-grid .select_sizes" ).change(function() {
    var value_select = $(this).val();    
    $('.option-values.variant_size').find('.option-value-input[value="'+ value_select +'"]').trigger('click');
    console.log(value_select,'1');
  });

  // $( ".content-area .below-main-image .wrap.thumb img" ).click(function(e) {
  //   e.preventDefault();
  //   $('.product-images .product-main-image img').remove();
  //   $('<img src="">').prependTo('.product-main-image');
  //   var value_radio = $(this).attr('src');
  //   $('.product-images .product-main-image img').attr('src',value_radio);
  // });

  
  $('.qty_plus').click(function(e){
        e.preventDefault();
      //  fieldName = $(this).attr('field');

        //Fetch qty in the current elements context and since you have used class selector use it.
        var qty = $(this).parents('.qty-info').find('.product-quantity-input');
        //var qty = $(this).closest('tr').find('input[name='+fieldName+']');

        var currentVal = parseInt(qty.val());
        if (!isNaN(currentVal)) {
            qty.val(currentVal + 1);
        } else {
            qty.val(0);
        }

        //Trigger change event
        qty.trigger('change');
    });

     $(".qty_minus").click(function(e) {
          e.preventDefault();
      //    fieldName = $(this).attr('field');
  
          //Fetch qty in the current elements context and since you have used class selector use it.
          var qty = $(this).parents('.qty-info').find('.product-quantity-input');
          //var qty = $(this).closest('tr').find('input[name='+fieldName+']');
  
          var currentVal = parseInt(qty.val());
          if (!isNaN(currentVal) && currentVal > 1) {
              qty.val(currentVal - 1);
          } else {
              qty.val(1);
          }
  
          //Trigger change event
          qty.trigger('change');
      }); 
  
});